// TODO: after add redux, this file must remove!

const hours = [{
	time_name: 'صبح',
	times: ['۰۶:۳۰', '۰۷:۰۰', '۰۷:۳۰', '۰۸:۰۰', '۰۸:۳۰', '۰۹:۰۰', '۰۹:۳۰', '۱۰:۰۰', '۱۰:۳۰', '۱۱:۰۰', '۱۱:۳۰'],
}, {
	time_name: 'ظهر',
	times: ['۱۲:۰۰', '۱۲:۳۰', '۱۳:۰۰', '۱۳:۳۰', '۱۴:۰۰', '۱۴:۳۰', '۱۵:۰۰', '۱۵:۳۰'],
}, {
	time_name: 'شب',
	times: ['۱۶:۰۰', '۱۶:۳۰', '۱۷:۰۰', '۱۷:۳۰', '۱۸:۰۰', '۱۸:۳۰', '۱۹:۰۰', '۱۹:۳۰', '۲۰:۰۰', '۲۰:۳۰', '۲۱:۰۰', '۲۱:۳۰', '۲۲:۰۰'],
}];

export default hours;
